var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 350,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#E0E0E0"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.3,
    d: "M0 0h500v350H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.849 120.883a6.54 6.54 0 0 1 6.488-6.494h117.836a6.492 6.492 0 0 1 6.488 6.494v104.742a6.541 6.541 0 0 1-6.488 6.495H189.337a6.495 6.495 0 0 1-6.488-6.495V120.883Zm117.732 6.587h-104.65v91.569l60.775-60.789a6.542 6.542 0 0 1 9.249 0l34.626 34.692V127.47Zm-91.571 26.162c0 7.225 5.857 13.081 13.082 13.081 7.224 0 13.081-5.856 13.081-13.081s-5.857-13.081-13.081-13.081c-7.225 0-13.082 5.856-13.082 13.081Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h500v350H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImage);
export default __webpack_public_path__ + "static/media/placeholder-image.47615446a99f198bfa3c72de94c54a99.svg";
export { ForwardRef as ReactComponent };